import React from 'react';
import { createRoot } from "react-dom/client";
import Setup from "./setup";
import * as serviceWorker from "./serviceWorker";
import "./i18n/i18n";

const appRoot = document.getElementById("root");

if (!appRoot) {
  console.error("Failed to find the root element");
} else {
  const root = createRoot(appRoot);
  try {
    root.render(<Setup />);
  } catch (error) {
    console.error("Error rendering application:", error);
  }
}

serviceWorker.unregister();
